module.exports = __webpack_public_path__ + "img/avatar.0d35eab2.jpeg";